import "./App.css";

import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";


// NAVBAR
import Navbar from "./Components/Navbar/Navbar.js";


// HOME
import DashboardContainer from "./Components/Home/DashboardContainer.js";


// BLOG
import Blog from "./Pages/Blog/Blog.js";
import Article from "./Pages/Blog/Article.js";


// CONTACT
import ContactPage from "./Pages/Contact/Contact.js";


// AUTH
import Login from "./Pages/Login.js";


// ADMIN
import AdminMessages from "./Components/Admin/AdminMessages.js";
import AdminBlog from "./Components/Admin/AdminBlog.js";
import AdminHome from "./Components/Admin/AdminHome.js";


function App() {
  return (
    <BrowserRouter>

      {/* UNE SEULE NAVBAR POUR TOUT LE SITE */}
      <Navbar />

      <Routes>

        <Route
          path="/"
          element={<DashboardContainer />}
        />

        <Route
          path="/blog"
          element={<Blog />}
        />

        <Route
          path="/blog/:slug"
          element={<Article />}
        />

        <Route
          path="/contact"
          element={<ContactPage />}
        />

        <Route
          path="/login"
          element={<Login />}
        />

        <Route
          path="/admin/blog"
          element={<AdminBlog />}
        />

        <Route
          path="/admin/contact"
          element={<AdminMessages />}
        />

        <Route
          path="/adminHome"
          element={<AdminHome />}
        />

      </Routes>

    </BrowserRouter>
  );
}

export default App;